import React from "react";
import { Form } from "react-bootstrap";
import SwitchButton2 from "../../../../Theme/switch-button-2/switch-button-2.component";
import styles from "./consumption-notifications.component.module.scss";
import { PercentageOption } from "../mock-data";

interface ConsumptionNotificationsHandlers {
  handleOverSubscriptionToggle: (value: boolean) => void;
  handleOverProspectToggle: (value: boolean) => void;
  handlePercentageToggle: (percentage: string) => void;
}

interface ConsumptionNotificationsComponentProps {
  isOverSubscriptionEnabled: boolean;
  isOverProspectEnabled: boolean;
  selectedPercentages: string[];
  percentageOptions: PercentageOption[];
  handleConsumptionNotifications: ConsumptionNotificationsHandlers;
}

const ConsumptionNotificationsComponent = ({
  isOverSubscriptionEnabled,
  isOverProspectEnabled,
  selectedPercentages,
  percentageOptions,
  handleConsumptionNotifications
}: ConsumptionNotificationsComponentProps) => {

  return (
    <div className={styles.container}>
      <div className={styles.toggleRow}>
        <label 
            htmlFor="over-subscription-toggle"
            className={styles.label}
          >
            Notify when over-subscripton
          </label>
        <SwitchButton2
          active={isOverSubscriptionEnabled}
          onChange={handleConsumptionNotifications.handleOverSubscriptionToggle}
        />
      </div>
      <div className={styles.percentageSection}>
        <div className={styles.percentageRow}>
          <label 
            htmlFor="over-prospect-toggle"
            className={styles.label}
          >
            Notify when over-prospect
          </label>
          <SwitchButton2
            active={isOverProspectEnabled}
            onChange={handleConsumptionNotifications.handleOverProspectToggle}
          />
        </div>
        <div className={styles.percentageOptions}>
          {percentageOptions.map((option) => (
            <div key={option.id} className={styles.percentageOption}>
              <div className={styles.checkboxGroup}>
                <Form.Group className="fixed-checkbox blue-checkbox fix-checkbox pointer-checkbox">
                  <Form.Check
                    type="checkbox"
                    id={`percentage-${option.id}`}
                    checked={selectedPercentages.includes(option.label)}
                    onChange={() => handleConsumptionNotifications.handlePercentageToggle(option.label)}
                    label=""
                  />
                </Form.Group>
              </div>
              <label
                htmlFor={`percentage-${option.id}`}
                className={styles.percentageLabel}
              >
                {option.label}
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ConsumptionNotificationsComponent;